import React, { useEffect, useState } from 'react';
import { CopyableText, CopyableTextTokens } from '@cp/shared/copyableText';
import { TypographyProps } from '@cp/ds/src/components/typography';
import { styled } from '@cp/ds/src/theme';
import { useInjection } from '@cp/shared/di';
import { SUPPORT_CODE_SERVICE } from './di';

const Root = styled('pre')({
  [CopyableTextTokens.ButtonPadding]: '2px',
  marginBlock: 0,
});

export const SupportCode = (props: TypographyProps) => {
  const service = useInjection(SUPPORT_CODE_SERVICE);
  const [code, setCode] = useState('');
  useEffect(() => {
    setCode(service.getCode());
  }, [service]);
  return (
    <Root {...props}>
      Ваш ID:&nbsp;<CopyableText sx={{ fontFamily: 'monospace' }}>{code}</CopyableText>
    </Root>
  );
};
